import React from "react";
import { useState,useContext } from "react";
import {
  formatIndianAmount,
  formatDaysAgo,
  addtoWishlist,
  getWishList,
} from "../Services/Helper";
import { ApiContext } from "../Context/Context";
import { useNavigate } from "react-router-dom";
import { LoggedInUserID } from "../Services/Urls";
import { toast } from "react-toastify";
import { PostRecords } from "../Services/ApiCall";
const NearByProperties = ({ onheartClick, ...data }) => {
      const {
      logindata,
      setlogindata,
      userData,
      setuserData,
      coordinates,
      setcoordinates,
  
      searchData,
      setsearchData,wishlist, setWishlist
    } = useContext(ApiContext);
  const defaultImage = "assets/img/property/property-22.jpg";
  const navigate = useNavigate();
  const imageSrc =
    typeof data?.Images === "string" && data.Images.trim() !== ""
      ? data.Images.split(",")[0].trim()
      : defaultImage;

  const handleNavigate = () => {
    const tabID =
      data?.PropertyTypeID === 1 && data?.VerticalID === 1
        ? 384
        : data?.PropertyTypeID === 1 && data?.VerticalID === 2
          ? 385
          : data?.PropertyTypeID === 1 && data?.VerticalID === 3
            ? 386
            : data?.PropertyTypeID === 2 && data?.VerticalID === 1
              ? 387
              : 388;

    navigate(`/property-details?id=${data?.ListingID}`, {
      state: {
        TabID: tabID,
      },
    });
  };

  //const [wishlist, setWishlist] = useState(getWishList() || []);

  const isWishlisted = (data) => {
    return wishlist.some(
      (item) =>
        item.ListingID === data?.ListingID &&
        item.VerticalID === data?.VerticalID &&
        item.PropertyTypeID === data?.PropertyTypeID,
    );
  };

  return (
    <div
      onClick={() => handleNavigate()}
      className="col-xl-6 col-lg-6 col-md-6"
      data-aos="fade-up"
      data-aos-duration={1200}
      data-aos-delay={200}
    >
      <div
        className="property-card pcardd style3 pscard22 nearbyy"
        style={{ display: "flex" }}
      >
        <div className="property-img" style={{ width: "30%" }}>
          <img
            src={imageSrc}
            alt="Property"
            style={{ width: "100%", height: "100%", objectFit: "cover" }}
          />
        </div>

        <div className="property-info" style={{ width: "70%" }}>
          <h3 className="headss">
            <a
              style={{
                display: "block",
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
                maxWidth: "80%",
              }}
            >
              {data.Title}
            </a>

            <i
              onClick={(e) => {
                e.stopPropagation(); // prevents parent click

                if( LoggedInUserID == null){
                  onheartClick();

                }else{
                   if(!isWishlisted(data)){
        
            let enqBody = [
              {
                ListingID: data?.ListingID,
                PropertyTypeID: data?.PropertyTypeID,
                VerticalID: data?.VerticalID,
                SellerName: data?.SellerName,
                SellerID: data?.SellerID,
                SellerMobile: data?.SellerMobile,
                UserName: userData?.User,
                UserID: userData?.UserID,
                UserMobile: userData?.Mobile,
                Remarks: `Wishlist Enquiry For ${data?.Title} `,
              },
            ];

            PostRecords(425, 1, enqBody, (data) => {
              if (data.hasErrors === false) {
                toast.success("Enquiry Sent Successfully");
              } else {
                toast.error("Error in sending Enquiry");
              }
            });


      }

                 addtoWishlist(data, wishlist, setWishlist);

                }
               
              }}
              style={{
                color: isWishlisted(data) ? "red" : "#ccc",
              }}
              className="ri-heart-fill"
            />
          </h3>
          <p>
            <i className="flaticon-location" />
            {data.Locality}
          </p>

          <div className="headss" style={{ marginLeft: -10 }}>
            <ul
              className="property-metainfo list-style"
              style={{ whiteSpace: "nowrap" }}
            >
              {Array.isArray(data?.UnitFurnishingtitle) &&
                data?.UnitFurnishingtitle?.length > 0 &&
                data?.UnitFurnishingtitle?.slice(0, 3)?.map((title, index) => (
                  <li key={index}>
                    <img
                      src={title?.UnitFurnishingIcon}
                      alt="Furniture"
                      style={{ height: 20, width: 20 }}
                      // className="furnishing-icon"
                    />
                    {title?.Quantity}
                  </li>
                ))}
            </ul>
            <p className="property-price">{formatIndianAmount(data.Price)}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NearByProperties;
